import { combineReducers } from 'redux';
import { all } from 'redux-saga/effects';

import {
  reducer as accountDetailsReducer,
  saga as accountDetailsSaga,
} from './accountDetailsPage/index';
import {
  reducer as contactDetailsReducer,
  saga as contactDetailsSaga,
} from './contactDetailsPage/index';
import routes from './routes';
import searchPageReducer from './searchPage/data/reducer';
import searchPageSaga from './searchPage/data/sagas';

const reducer = combineReducers({
  accountDetails: accountDetailsReducer,
  contactDetails: contactDetailsReducer,
  searchPage: searchPageReducer,
});

const saga = function* () {
  yield all([accountDetailsSaga(), contactDetailsSaga(), searchPageSaga()]);
};

export { reducer, routes, saga };
